import { jsx as M } from "react/jsx-runtime";
import { useRef as G, useEffect as p, useMemo as V } from "react";
import D from "../../../../make-cancellable-promise/dist/esm/index.es.js";
import { clsx as O } from "../../../../clsx/dist/clsx.es.js";
import u from "../../../../tiny-invariant/dist/esm/tiny-invariant.es.js";
import l from "../../../../warning/warning.es.js";
import { AnnotationLayer as F } from "../../../node_modules/pdfjs-dist/build/pdf.es.js";
import I from "../shared/hooks/useDocumentContext.es.js";
import N from "../shared/hooks/usePageContext.es.js";
import U from "../shared/hooks/useResolver.es.js";
import { cancelRunningTask as $ } from "../shared/utils.es.js";
function nn() {
  const b = I(), d = N();
  u(d, "Unable to find Page context.");
  const v = Object.assign(Object.assign({}, b), d), { imageResourcesPath: m, linkService: i, onGetAnnotationsError: g, onGetAnnotationsSuccess: y, onRenderAnnotationLayerError: A, onRenderAnnotationLayerSuccess: E, page: n, pdf: s, renderForms: L, rotate: S, scale: w = 1 } = v;
  u(s, "Attempted to load page annotations, but no document was specified. Wrap <Page /> in a <Document /> or pass explicit `pdf` prop."), u(n, "Attempted to load page annotations, but no page was specified."), u(i, "Attempted to load page annotations, but no linkService was specified.");
  const [x, e] = U(), { value: t, error: f } = x, P = G(null);
  l(Number.parseInt(window.getComputedStyle(document.body).getPropertyValue("--react-pdf-annotation-layer"), 10) === 1, "AnnotationLayer styles not found. Read more: https://github.com/wojtekmaj/react-pdf#support-for-annotations");
  function _() {
    t && y && y(t);
  }
  function C() {
    f && (l(!1, f.toString()), g && g(f));
  }
  p(function() {
    e({ type: "RESET" });
  }, [e, n]), p(function() {
    if (!n)
      return;
    const o = D(n.getAnnotations()), c = o;
    return o.promise.then((a) => {
      e({ type: "RESOLVE", value: a });
    }).catch((a) => {
      e({ type: "REJECT", error: a });
    }), () => {
      $(c);
    };
  }, [e, n]), p(() => {
    if (t !== void 0) {
      if (t === !1) {
        C();
        return;
      }
      _();
    }
  }, [t]);
  function h() {
    E && E();
  }
  function k(r) {
    l(!1, `${r}`), A && A(r);
  }
  const R = V(() => n.getViewport({ scale: w, rotation: S }), [n, S, w]);
  return p(function() {
    if (!s || !n || !i || !t)
      return;
    const { current: o } = P;
    if (!o)
      return;
    const c = R.clone({ dontFlip: !0 }), a = {
      accessibilityManager: null,
      // TODO: Implement this
      annotationCanvasMap: null,
      // TODO: Implement this
      annotationEditorUIManager: null,
      // TODO: Implement this
      div: o,
      l10n: null,
      // TODO: Implement this
      page: n,
      structTreeLayer: null,
      // TODO: Implement this
      viewport: c
    }, T = {
      annotations: t,
      annotationStorage: s.annotationStorage,
      div: o,
      imageResourcesPath: m,
      linkService: i,
      page: n,
      renderForms: L,
      viewport: c
    };
    o.innerHTML = "";
    try {
      new F(a).render(T), h();
    } catch (j) {
      k(j);
    }
    return () => {
    };
  }, [t, m, i, n, s, L, R]), M("div", { className: O("react-pdf__Page__annotations", "annotationLayer"), ref: P });
}
export {
  nn as default
};
//# sourceMappingURL=AnnotationLayer.es.js.map
